import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from 'react';
import { useCustomerData as useCustomerDataHook, } from '@planter/common';
var CustomerDataContext = createContext(undefined);
export var CustomerDataProvider = function (_a) {
    var children = _a.children;
    var _b = useCustomerDataHook(), customer = _b.customer, isLoading = _b.isLoading, error = _b.error;
    return (_jsx(CustomerDataContext.Provider, { value: { customer: customer, isLoading: isLoading, error: error }, children: children }));
};
export var useCustomerData = function () {
    var context = useContext(CustomerDataContext);
    if (context === undefined) {
        throw new Error('useCustomerData must be used within a CustomerDataProvider');
    }
    return context;
};
